import { useAnalytics } from 'use-analytics';
import { useEffect } from 'react';
import useLoanApplicationProcess from './LoanApplicationProcessProvider/useLoanApplicationProcess';

const useLoanAmountTracker = () => {
  const { track } = useAnalytics();
  const { loanAmount } = useLoanApplicationProcess();

  useEffect(() => {
    track('calculator', {
      description: 'amount',
      value: loanAmount,
    });
  }, [track]);
};

export default useLoanAmountTracker;
